module.exports = __webpack_public_path__ + "static/media/Sunflower-Village-By-Laws.12f34ee9.pdf";